import { useState, useEffect, useMemo } from "react";
import axios from "axios";

const useArticle = (
  signalId?: string,
  page?: number,
  notFollowed?: boolean,
  userId?: string
): any => {
  const [data, setData] = useState<any | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      setError(null);

      try {
        const params: any = {
          page: page,
        };

        // Always include userId when available
        if (userId) {
          params.userId = userId;
        }

        if (signalId) {
          params.signalId = signalId;
        } else if (notFollowed) {
          params.notFollowed = notFollowed;
        }

        const response = await axios.get(
          `https://oparl-textprovider-production.up.railway.app/articles`,
          //`http://localhost:1080/articles`,
          {
            params,
          }
        );
        setData(response.data);
        console.log("response.data", response.request);
      } catch (err) {
        if (axios.isAxiosError(err) && err.response) {
          setError(`Error: ${err.response.statusText}`);
        } else if (err instanceof Error) {
          setError(err.message);
        } else {
          setError("An unknown error occurred");
        }
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [signalId, page, notFollowed, userId]);

  return { data, loading, error };
};

export default useArticle;
